import React from 'react'
import styled from 'styled-components'
import { number, string } from 'prop-types'

const StyledImage = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`

export const Image = ({ channel, ...rest }) => {
  if (!channel) return null
  return <StyledImage src={channel} alt='' />
}

Image.propTypes = {
  channel: string,
  height: number,
}
